var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, css, LitElement, customElement, property } from 'lit-element';
let CSTLoadingElement = class CSTLoadingElement extends LitElement {
    constructor() {
        super(...arguments);
        this.size = 48;
    }
    render() {
        return html `
      <img src="images/circle-loader.svg" height=${this.size} width=${this.size} />
    `;
    }
};
CSTLoadingElement.styles = css `
    img {
      display: block;
    }
  `;
__decorate([
    property({ type: Number, reflect: true })
], CSTLoadingElement.prototype, "size", void 0);
CSTLoadingElement = __decorate([
    customElement('cst-loading')
], CSTLoadingElement);
export default CSTLoadingElement;
//# sourceMappingURL=cst-loading.js.map